import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import transactionReducer from './slices/transactionSlice';
import budgetReducer from './slices/budgetSlice';
import debtReducer from './slices/debtSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import recurringReducer from './slices/recurringSlice';
// 12 ago 2026 (Augusto: "el feature de Voz no está disponible en el
// website"): la causa real -- voiceSlice.js existía y VoiceCommands.js
// (la pantalla de /voice) ya hacía useSelector((state) => state.voice...),
// pero este reducer nunca se registró acá. Sin esto, state.voice es
// undefined y la pantalla se rompe en blanco apenas intenta leer
// state.voice.commands -- por eso "no estaba disponible": no era que
// faltara el link (ya se había agregado al sidebar), la pantalla en sí
// crasheaba al cargar.
import voiceReducer from './slices/voiceSlice';
// 4 sep 2026 (Augusto: "Informes me aparece en blanco"): mismo bug que
// el de Voz de arriba -- reportSlice.js existía y Reports.js ya hacía
// useSelector((state) => state.reports.monthly), pero este reducer
// nunca se registró acá. state.reports quedaba undefined y la pantalla
// crasheaba en blanco apenas intentaba leer state.reports.monthly.
import reportReducer from './slices/reportSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    transactions: transactionReducer,
    budgets: budgetReducer,
    debts: debtReducer,
    subscription: subscriptionReducer,
    recurring: recurringReducer,
    voice: voiceReducer,
    reports: reportReducer,
  },
});

export default store;
